<template>
    <div class="row align-items-end">
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Şube</label>
            <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Şube"></v-select-list>
        </div>
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Grup</label>
            <v-select-list :options="groups" label="Name" v-model="group" placeholder="Grup"></v-select-list>
        </div>
        <div class="col-auto">
            <button class="btn btn-secondary" v-on:click="$emit('filter',filter)">Filtrele</button>
        </div>
        <div class="col-auto">
            <button class="btn btn-dark" v-on:click="clearForm">Temizle</button>
        </div>
    </div>
</template>

<script>
import CompanyApi from '@/api/company'
import HumanResourcesParameterApi from '@/api/human-resources-parameters'

export default {
    data(){
        return {
            filter:{
                BranchId:null,
                SalaryEffectTypeGroupId:null
            },
            branches:[],
            groups:[]
        }
    },
    mounted(){
        this.getBranches()
        this.getGroups()
    },
    methods:{
        clearForm(){
            this.filter.BranchId = null
            this.filter.SalaryEffectTypeGroupId = null
            this.$emit('filter',this.filter)
        },
        getBranches(){
            return new Promise((resolve)=>{
                CompanyApi.Branch.ListByCode("S").then(res=>{
                    this.branches = res.data.Data
                    resolve()
                })
            })
        },
        getGroups(){
            HumanResourcesParameterApi.SalaryEffect.TypeGroup.List().then(res=>{
                this.groups = res.data.Data
            })
        }
    },
    computed:{
        branch:{
            get:function(){
                return this.branches.find(s=>s.Id==this.filter.BranchId)
            },
            set:function(value){
                debugger;
                this.filter.BranchId = value?.Id || null
            }
        },
        group:{
            get:function(){
                return this.groups.find(s=>s.Id==this.filter.SalaryEffectTypeGroupId)
            },
            set:function(value){
                debugger;
                this.filter.SalaryEffectTypeGroupId = value?.Id || null
            }
        }
    }
}
</script>